<template>
	<div>
		<div>
			<section>
				<div v-if="$route.path == '/StockOut/StockOutByPage'">
					<el-form :inline="true" class="toolbar">
						<el-form-item label="销售下单号:" label-width="90px">
							<el-input v-model="query.OrderCode" class="formlength"></el-input>
						</el-form-item>
						<el-form-item label="出库单号:" label-width="80px">
							<el-input v-model="query.OutCode" class="formlength"></el-input>
						</el-form-item>
						<el-form-item label="代理商:" label-width="76px">
							<el-input v-model="query.AgentName" class="formlength"></el-input>
						</el-form-item>
						<el-form-item label="联系人:" label-width="80px">
							<el-input v-model="query.c_name" class="formlength"></el-input>
						</el-form-item>
						<!--<el-form-item label="所属区域:" label-width="80px">
								<el-input v-model="query.AreaName" class="formlength"></el-input>
							</el-form-item>-->
						<el-form-item label="物流单号:" label-width="80px">
							<el-input v-model="query.LogCode"></el-input>
						</el-form-item>
	
						<el-form-item label="出库单状态:" label-width="100px" v-if="false">
							<el-select placeholder="-请选择-" class="formlength" v-model="query.Status">
								<el-option v-for="option in queryType" :value="option.TypeValue" :label="option.TypeName">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="收货状态:" label-width="90px">
							<el-select placeholder="-请选择-" class="formlength" v-model="query.ReceivingStatus">
								<el-option v-for="option in queryDelivery" :value="option.TypeValue" :label="option.TypeName">
								</el-option>
							</el-select>
						</el-form-item>
						<el-button type="primary" @click="onQuerySubmit" icon="search">查询</el-button>
						<el-button type="primary" @click="onQueryClean" icon="delete2">重置</el-button>
					</el-form>
					<div>
						<el-table :data="lists" v-loading="loading2" element-loading-text="拼命加载中" border style="width: 100%;" @selection-change="selsChange" router>
							<el-table-column label="出库单号" prop="StockOutCode" width="200"></el-table-column>
							<el-table-column label="代理商" prop="AgentName" width="200"></el-table-column>
							<el-table-column label="主联系人" prop="C_Name"></el-table-column>
							<el-table-column label="销售下单号" prop="OrderCode" width="200"></el-table-column>
							<el-table-column label="所属区域" prop="AreaName" width="200"></el-table-column>
							<el-table-column label="出库单下单时间" prop="StockOutTime" width="200"></el-table-column>
							<el-table-column label="业务员" prop="SaleEmployeeName" width="200"></el-table-column>
							<el-table-column label="实际签收时间" prop="SignTime" width="200"></el-table-column>
							<el-table-column label="物流单号" prop="LogisticsCode" width="200"></el-table-column>
							<!--<el-table-column label="出库单状态" prop="StatusName" width="200"></el-table-column>-->
							<el-table-column label="收货状态" prop="ReceivingStatusName" width="200"></el-table-column>
							<el-table-column label="操作" width="200px" fixed="right">
								<template scope="scope">
									<el-button size="small" @click="handleView(scope.$index, scope.row)" icon="view" type="success">查看</el-button>
									<el-button size="small" icon="edit" @click="EditHandle(scope.$index, scope.row)" :disabled="(scope.row.btnVue&4)<=0" type="primary">修改</el-button>
									<!--<el-button size="small" icon="delete" @click="handleDel(scope.$index, scope.row)" :disabled="(scope.row.btnVue&8)<=0" type="danger">删除</el-button>
										<el-button size="small" icon="circle-cross" @click="EnableHandle(scope.$index, scope.row)" :disabled="(scope.row.btnVue&16)<=0" type="warning">作废</el-button>-->
								</template>
							</el-table-column>
						</el-table>
					</div>
					<el-col :span="24" class='btm-action'>
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalSize*1" style="float: right">
						</el-pagination>
					</el-col>
				</div>
				<div v-else>
					<router-view></router-view>
				</div>
			</section>
	
			<!--查看-->
			<el-dialog title="销售下单审核" v-model="SaleCheckView" size="tiny">
				<el-form style="margin:20px;width:60%;min-width:100%" label-width="100px">
	
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="SaleCheckView=false">通 过</el-button>
					<el-button type="primary" @click="SaleCheckView=false">驳 回</el-button>
					<el-button @click="SaleCheckView=false">取 消</el-button>
	
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import StockOutControl from './StockOutControl.js';
module.exports = StockOutControl
</script>

<style scoped>
.btm-action {
	display: flex;
	justify-content: center;
	margin: 5px 0px;
}

.formlength {
	width: 160px;
}
</style>


// WEBPACK FOOTER //
// StockOut.vue?d2fdf8ca